import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
// import { HttpStatus } from '@core/classes/http-status.class';

// import * as Objects from '@core/objects';
// import * as Access from '@app/models/access';
import { RecordingConfig } from '@core/models/recording-config.model';
import { Record } from '@core/store/models/recorder.class';

import { NotificationData } from "@core/store/models/notifications.interface";


export enum RecorderActionType {

	// EVENT CALLS
    Init = "[Recorder] - Initialize the Record  according options",
    Start = "[Recorder] - Prepare the streams for recording according options",
    StartSuccess = "[Recorder] - Start Success: launch recording after preparation",
    StartFail = "[Recorder] - Start Fail: some error launching the recording",
    Stop = "[Recorder] - Stop: prepare the streams to stop recording",
    StopSuccess = "[Recorder] - Stop Success: halt the recording after preparation",
    StoreStreamChunk = "[Recorder] - save new video chunk form recording",
    Clear = "[Recorder] - Clear current record",
    Finish = "[Recorder] - Set recorder status when process is finished",
}

// Load Available Events
export class Init implements Action {
    readonly type = RecorderActionType.Init;
    constructor(public config: RecordingConfig, public data: NotificationData) {}
}

export class Start implements Action {
    readonly type = RecorderActionType.Start;
    constructor(public record: Record) {}
}

export class StartSuccess implements Action {
    readonly type = RecorderActionType.StartSuccess;
    constructor( public record: Record, public mediaRecorder: MediaRecorder) {}
}

export class StoreStreamChunk implements Action {
    readonly type = RecorderActionType.StoreStreamChunk;
    constructor( public chunk: Blob) {}
}

export class StartFail implements Action {
    readonly type = RecorderActionType.StartFail;
    constructor( public error: HttpErrorResponse, public record?: Record) {}
}


export class Stop implements Action {
    readonly type = RecorderActionType.Stop;
    constructor() {}
}

export class StopSuccess implements Action {
    readonly type = RecorderActionType.StopSuccess;
    constructor() {}
}

export class Clear implements Action {
    readonly type = RecorderActionType.Clear;
    constructor() {}
}

export class Finish implements Action {
    readonly type = RecorderActionType.Finish;
    constructor(public success: boolean) {}
}

export type RecorderActions = 	Init | 
                                Start | 
                                StartSuccess | 
                                StartFail | 
                                Stop | 
                                StopSuccess | 
                                StoreStreamChunk | 
                                Clear | 
                                Finish;
